export const ROOT = '/';
export const FORM = '/form';
export const ACTIVATE = '/activate';
export const VERIFY_EMAIL = '/verify/:email';
export const EXTEND_TRIAL = '/extend-trial';
export const EXISTING_EMAIL = '/existing-user';
export const VERIFICATION_ERROR = '/verification-error';

export const crumbs = [ROOT, FORM, VERIFY_EMAIL, ACTIVATE, EXISTING_EMAIL, VERIFICATION_ERROR];
